import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * Blocks rendering until the session has been resolved, then either renders the
 * children or redirects to /login. Prevents the "logged out on hard refresh"
 * race where isAuthenticated is still false while /auth/me is in flight.
 */
export const RequireAuth = ({ children, role }) => {
  const { isAuthenticated, isAdmin, isAgent, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-[#00a1de]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ redirect: location.pathname }} replace />;
  }

  if (role === 'admin' && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (role === 'agent' && !isAgent && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireAuth;
